<template>
  <div class="modal" tabindex="-1" role="dialog" v-if="isVisible">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">総務チェック（業者請求確認）</h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">キャンセル</button>
          <button type="button" class="btn btn-primary" @click="registerGeneralAffairsVendorCheck">
            確認登録
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { generalAffairsVendorCheck } from '@/api/axios';

export default {
  emits: ['onClose'],
  setup(_, { emit }) {
    const store = useStore();
    const router = useRouter();
    const isVisible = ref(false);
    const temporaryWorkData = reactive({
      id: null,
      year: null,
      month: null,
      confirm_vendor_billing: null,
      vendor_billing_confirm_dt: new Date().toISOString().substring(0, 10), // デフォルトで今日の日付,
    });

    // 呼び出し元を保持するための変数
    const callerSource = ref('');

    const show = ({ temporaryWorkId, year, month, source }) => {
      temporaryWorkData.id = temporaryWorkId;
      temporaryWorkData.year = year;
      temporaryWorkData.month = month;
      temporaryWorkData.confirm_vendor_billing = true;
      temporaryWorkData.vendor_billing_confirm_dt = new Date().toISOString().substring(0, 10); // デフォルト日付
      callerSource.value = source; // 呼び出し元を保持
      isVisible.value = true;
    };

    const closeModal = () => {
      isVisible.value = false;
    };

    const registerGeneralAffairsVendorCheck = async () => {
      try {
        await generalAffairsVendorCheck(temporaryWorkData.id, temporaryWorkData);
        store.dispatch('setFlashMessage', { message: '総務チェック（業者請求確認）完了！', type: 'success' });
        // 呼び出し元に応じてパスを変更
        const path = '/temporary-works';

        router.push({
          path,
          query: { year: temporaryWorkData.year, month: temporaryWorkData.month },
        });
        closeModal();
        emit('onClose'); // 親コンポーネントに通知
      } catch (error) {
        console.error('総務チェック（業者請求確認）登録エラー:', error);
      }
    };

    return {
      isVisible,
      temporaryWorkData,
      show,
      closeModal,
      registerGeneralAffairsVendorCheck,
    };
  },
};
</script>

<style scoped>
.modal {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-dialog {
  max-width: 500px;
}
</style>
